// require('./main');
// require('./index');

$(document).ready(function () {

    /*
        1. Trigger de formulario, intercambia el estado de deshabilitado
    */

    /*
        1. Trigger de formulario, intercambia el estado de deshabilitado

        El formulario se desactiva o activa el botón de envio
    */
    // $("#acceptTerm").click(function () {
    //     $("#sendRequest").attr("disabled", !this.checked);
    // });

    // $("#acceptTermNewLetter").click(function () {
    //     $("#sendRequestNewLetter").attr("disabled", !this.checked);
    // });

    // $('.nav-toggle-btn').toggleClass('toggle');
    if (screen.width >= 768)
        $('#nav-movil').remove();
    else {
        $('#nav-desktop').remove();

    }
    if (screen.width >= 768)
        $('.movil').remove();
    else {
        $('.desktop').remove();
    }

    // Paralax
    let animate = $('.animate');

    function showAnimate() {
        let scrollTop = $(window).scrollTop();

        for (var i = 0; i < animate.length; i++) {

            let heightAnimate = animate[i].offsetTop;
            if (screen.width >= 768) {
                if (heightAnimate - 500 < scrollTop) {
                    animate[i].style.opacity = 1;
                    animate[i].classList.add('showUp');
                }
            }
            if (screen.width >= 1400) {
                if (heightAnimate - 600 < scrollTop) {
                    animate[i].style.opacity = 1;
                    animate[i].classList.add('showUp');
                }
            }
            if (screen.width >= 1920) {
                if (heightAnimate - 900 < scrollTop) {
                    animate[i].style.opacity = 1;
                    animate[i].classList.add('showUp');
                }
            } else {
                if (heightAnimate - 500 < scrollTop) {
                    animate[i].style.opacity = 1;
                }
            }
        }
    }

    window.addEventListener('scroll', showAnimate);

    // Por defecto aparece el submenú
    $("#sub-menu").fadeIn(200);

    // MetisMenu
    // var sideMenu = $('#side-menu').metisMenu();

    // sideMenu.on('shown.metisMenu', function (e) {
    //     fix_height();
    // });

    // Abrir Menu principal
    $('.nav-toggle-btn').on('click', function (e) {
        e.preventDefault();

        if ($(this).hasClass('toggle')) {
            //Oculto el menu principal
            $('#site-menu').fadeOut(1);
            $(this).removeClass('site-menu-close');
            $('.nav-toggle-btn').toggleClass('toggle');

            // Ocultamos el menu y lo volvemos de color blanco
            $('#nav-desktop>.menu-top>.row').addClass('bg-white');
            $('#nav-movil>.menu-icons>.row').addClass('bg-white');
            $('main').removeClass('position-fixed');
            /* $('#nav-desktop').css('background-color', 'white');
            $('#nav-movil').css('background-color', 'white'); */
            $('.menu-logo-sten img').fadeIn(1);
            $('.menu-arrow a').fadeIn(1);
            /* $('main').fadeIn(1); */
        } else {
            $('.nav-toggle-btn').toggleClass('toggle');

            // Ocultamos el menu y lo volvemos transparente
            $('#nav-desktop>.menu-top>.row').removeClass('bg-white');
            $('#nav-movil>.menu-icons>.row').removeClass('bg-white');
            $('main').addClass('position-fixed');
            /* $('#nav-desktop').css('background-color', '#313131').fadeIn(200);
            $('#nav-movil').css('background-color', '#313131').fadeIn(200); 
            $('#nav-desktop').css('border', 'none');
            $('#nav-movil').css('border', 'none');*/
            $(this).addClass('site-menu-close');
            //muestro el menu principal
            $('#site-menu').fadeIn(1);
            $('.menu-logo-sten img').fadeOut(1);
            /* $('main').fadeOut(1); */
            $('.menu-arrow a').fadeOut(1);
        }
    });

    // Sub menu secundario
    $('#btn-arrow').on('click', function (e) {
        e.preventDefault();

        $("#sub-menu").toggle(function () {
        }, function () {
        });

        $(this).toggleClass("down");
    });

    // Simbolos de + y - en menu
    $('.menu-collapse').on('click', function (e) {
        let id = $(this).attr('id');
        let href = $(this).attr('href');
        // Oculto
        $(href).on("hide.bs.collapse", function () {
            $('#' + id).find('.more').html('+');
        });
        // Mostrar
        $(href).on("show.bs.collapse", function () {
            $('#' + id).find('.more').html('-');
            $('.collapse').collapse('hide');
        });
    });

    // Hover sobre el slide
    $('.hover-slide').hover(
        function () {
            $(this).find('.right-slider img').css('opacity', '1');
            $(this).find('.right-slider img').fadeIn(200);
        }, function () {
            $(this).find('.right-slider img').css('opacity', '0');
            $(this).find('.right-slider img').fadeOut(200);
        }
    );

    // Anclas desde URL
    var ancla = window.location.hash.substring(1);
    if (ancla.length > 0) {
        $('#site-menu').hide();

        // Compruebo si existe el ancla
        let elAncla = $('#' + ancla);
        if (elAncla && elAncla.offset()) {
            $('html, body').animate({scrollTop: elAncla.offset().top}, 500);
        }

    }

    // Ancla desde Click href
    $('a[href^="#"]').on('click', function (e) {
        let ancla = this.hash.substring(1);
        if (ancla.length > 0 && ancla != 'sobre-sten-menu' && ancla != 'servicios-menu' && ancla != 'encofrados-menu' && ancla != 'proyectos-menu') {
            $('#site-menu').fadeOut(1);
            $(this).addClass('site-menu-close');
            $('.nav-toggle-btn').removeClass('toggle');
            $('#nav-desktop').css('background-color', 'white');
            $('#nav-movil').css('background-color', 'white');
            $('.menu-logo-sten img').fadeIn(1);
            $('.menu-arrow i').fadeIn(1);
            $('main').fadeIn(1);
            $('html, body').animate({scrollTop: $('#' + ancla).offset().top}, 500);
        }
    });

    // Detectar Scroll para aparecer y ocultar submenú
    let position = $(window).scrollTop();

    /* $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if(scroll > position) {
            $("#sub-menu").fadeOut(200);
        } else {
            $("#sub-menu").fadeIn(200);
        }
        position = scroll;
    }); */

    // Cambiar de idioma
    function changeLanguage(ext_url, lang) {
        window.location = ext_url + '/' + lang;
    }
    window.changeLanguage = changeLanguage;

    // Ocultar y mostrar elementos del filtro
    function showHide(elementId) {
        let elements = document.querySelectorAll(elementId);
        elements.forEach(element => {
            element.classList.toggle("d-none");
        });
    }
    window.showHide = showHide;

    // Ocultar y mostrar elementos del filtro
    function showHideFilter(elementId) {
        console.log("showHideFilter");
        let elements = document.querySelectorAll(elementId);
        if (elements == null || elements.length == 0) return;

        elements.forEach(el => {
            el.classList.toggle("d-none");
        });
    }
    window.showHideFilter = showHideFilter;

    /**
     * Clase para filtrar los elementos por grupo
     */
    function checkSelections(){
        let radioBtns = document.querySelectorAll('[data-filter]');

        radioBtns.forEach(radioBtn => {
            radioBtn.addEventListener('click', function(e){
                let filter = e.target.dataset.filter;
                let selection = e.target.name;

                if (filter == 'all') {
                    filterByAll(selection);
                } else {
                    filterBy(selection, filter);
                }
            });
        });
    }

    /**
     * Clase para filtrar los tags
     */
    function checkTagSelections(){
        let tags_elements = document.querySelectorAll('[data-tag-id][data-tag-search]');

        tags_elements.forEach(tag_element => {
            tag_element.addEventListener('click', function(e){
                let tag_id = e.target.dataset.tagId;
                console.log("tag_element", tag_element, tag_id);
                let group_selection = 'tag';
                filterBy(group_selection, tag_id);
            });
        });
    }

    /**
     * Filtra los elementos segun el grupo seleccionado
     * 
     * @param {string} groupId 
     */
    function filterBy(groupId, id) {

        let tagSelectName = getTagSelectName(groupId);

        console.log("> tagSelectName", tagSelectName);
        if (tagSelectName == 'data-publish-date') {
            filterByTimestampDate(tagSelectName, id);
        } else {
            filterByGroupSlug(tagSelectName, id);
        }

    }

    /**
     * Obtiene el nombre del atributo que se usa para filtrar
     * 
     * @param {string} groupId 
     */
    function getTagSelectName(groupId) {
        let tagSelectName = 'data-product-id';

        switch (groupId) {
            case 'tipologia':
                tagSelectName = "data-content-group-id";
                break;
            case 'sistema-de-encofrado':
                tagSelectName = "data-product-id";
                break;
            case 'fecha-de-publicacion':
                tagSelectName = "data-publish-date";
                break;
            case 'tag':
                tagSelectName = "data-tag-id";
                break;
        }

        return tagSelectName;
    }

    /**
     * Filtra los elementos segun el grupo seleccionado y la fecha de publicacion
     * 
     * @param {string} groupId 
     */
    function filterByTimestampDate(tagSelectName, groupSlug) {
        
        let items = document.querySelectorAll(`[${tagSelectName}]`);
        let itemsHiden = document.querySelectorAll(`div[${tagSelectName}]:not([${tagSelectName}="${groupSlug}"])`);

        itemsHiden.forEach(item => {
            item.setAttribute([`hidden-${tagSelectName}`], 1);
        });

        let selectDate = getTimestampFilter(groupSlug);
        items.forEach(item => {
            let itemDate = item.getAttribute(tagSelectName);
            if (itemDate >= selectDate) {
                item.setAttribute([`hidden-${tagSelectName}`], 0);
            } else {
                item.setAttribute([`hidden-${tagSelectName}`], 1);
            }
        });
    }

    /**
     * Obtiene el timestamp de la fecha de publicacion
     * 
     * @param {string} groupId 
     */
    function getTimestampFilter(stringDate) {
        let today = new Date().setHours(0,0,0,0);

        let selectDate = 0;
        switch (stringDate) {
            case "today":
                // get today date timestamp with 00:00:00 time
                selectDate = today;
                break;
            case "week":
                // get current monday week date timestamp with 00:00:00 time
                let currentMonday = new Date(today - (new Date().getDay() - 1) * 24 * 60 * 60 * 1000).setHours(0,0,0,0);
                selectDate = currentMonday;
                break;
            case "month":
                // get first day of last month date timestamp with 00:00:00 time
                let firstDayLastMonth = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).setHours(0,0,0,0);
                selectDate = firstDayLastMonth;
                break;
            case "year":
                // get first day of last year date timestamp with 00:00:00 time
                let firstDayLastYear = new Date(new Date().getFullYear(), 0, 1).setHours(0,0,0,0);
                selectDate = firstDayLastYear;
                break;
        }

        return selectDate / 1000;
    }

    /**
     * Filtra los elementos segun el grupo seleccionado
     * 
     * @param {string} groupId 
     */
    function filterByGroupSlug(tagSelectName, groupSlug) {
        
        let items = document.querySelectorAll(`[${tagSelectName}*="${groupSlug}"]`);
        let itemsHiden = document.querySelectorAll(`div[${tagSelectName}]:not([${tagSelectName}="${groupSlug}"])`);

        itemsHiden.forEach(item => {
            item.setAttribute([`hidden-${tagSelectName}`], 1);
        });

        items.forEach(item => {
            let list_products_ids = item.getAttribute(tagSelectName).split(',');
            if(list_products_ids.includes(groupSlug)){
                item.setAttribute([`hidden-${tagSelectName}`], 0);
            }
        });
    }

    /**
     * Muetra todos los elementos segun el grupo seleccionado
     * 
     * @param {string} groupId 
     */
    function filterByAll(groupId) {
        let tagSelectName = getTagSelectName(groupId);

        let items = document.querySelectorAll(`div[${tagSelectName}]`);

        items.forEach(item => {
            item.setAttribute([`hidden-${tagSelectName}`], 0);
        });
    }
    
    checkSelections();
    checkTagSelections();

    function toggleSubmenu() {
        // Variable para determinar si estamos moviendonos hacia abajo o arriba
        var lastKnownScrollPosition_nav = 0;

        // buscamos y asignamos los elementos de la navegacion
        var principalNavBar = document.getElementById('nav-desktop')
        var secondaryNavBar = document.getElementById('sub-menu')

        document.addEventListener("scroll", function(event) {

            if (!principalNavBar || !secondaryNavBar) {
                return;
            }
            // Determinamos si se oculta o se muestra la barra de navegacion principal
            // dependiendo de la direccion de scroll
            if (lastKnownScrollPosition_nav > window.scrollY) {
                principalNavBar.classList.remove('menu-hidden')
                secondaryNavBar.classList.remove('menu-hidden')
            } else {
                principalNavBar.classList.add('menu-hidden')
                secondaryNavBar.classList.add('menu-hidden')
            }

            // Oculta el logo principal, según el desplazamiento
            lastKnownScrollPosition_nav = window.scrollY;

        });
    }

    toggleSubmenu();

    /**
     * Click en el filtro del menu en la pagina de proyectos
     */
    function clickFilterItemOnMenu(filterId, filterName) {
        let elFilter = document.querySelector(`[name="tipologia"][data-filter="${filterId}"]`);
        if (elFilter) {
            elFilter.click();
        }
    }

    window.clickFilterItemOnMenu = clickFilterItemOnMenu;
    

    // 2. Editor texto:
    if ($('.editor').length > 0) {
        $('.editor').trumbowyg({
            lang: "es",
            autogrow: true,
            removeformatPasted: true,
            svgPath: '/plugins/trumbowyg/ui/icons.svg',
            semantic: {
                'div': 'div' // Editor does nothing on div tags now
            },
            tagClasses: {
                img: "responsive rounded max-h-40"
            },
            semantic: false,
            btns: [
                ['viewHTML'],
                ['undo', 'redo'], // Only supported in Blink browsers
                ['fontsize'],
                ['formatting'],
                ['strong', 'em', 'del'],
                ['foreColor', 'backColor'],
                ['superscript', 'subscript'],
                ['link'],
                ['image'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                ['unorderedList', 'orderedList'],
                ['table'],
                ['horizontalRule'],
                ['removeformat'],
                ['fullscreen']
            ],
            btnsDef: {
                image: {
                    dropdown: ['insertImage', 'upload'],
                    ico: 'insertImage'
                }
            },
            plugins: {
                colors: {
                    colorList: [
                        'ffffff', '000000', 'eeece1', '1f497d', '4f81bd', 'c0504d', '9bbb59', '8064a2', '4bacc6', 'f79646', 'ffff00',
                        'f2f2f2', '7f7f7f', 'ddd9c3', 'c6d9f0', 'dbe5f1', 'f2dcdb', 'ebf1dd', 'e5e0ec', 'dbeef3', 'fdeada', 'fff2ca',
                        'd8d8d8', '595959', 'c4bd97', '8db3e2', 'b8cce4', 'e5b9b7', 'd7e3bc', 'ccc1d9', 'b7dde8', 'fbd5b5', 'ffe694',
                        'bfbfbf', '3f3f3f', '938953', '548dd4', '95b3d7', 'd99694', 'c3d69b', 'b2a2c7', 'b7dde8', 'fac08f', 'f2c314',
                        'a5a5a5', '262626', '494429', '17365d', '366092', '953734', '76923c', '5f497a', '92cddc', 'e36c09', 'c09100',
                        '7f7f7f', '0c0c0c', '1d1b10', '0f243e', '244061', '632423', '4f6128', '3f3151', '31859b', '974806', '7f6000',
                        '313131', '231f20', 'f40d18', 'd60812', 'd90711'
                    ],
                    displayAsList: false,
                },
                upload: {
                    serverPath: '/api/admin/upload-image-ajax',
                    fileFieldName: 'image',
                }
            }
            // plugins: {
            //     fontsize: {
            //         sizeList: [
            //             '11px',
            //             '12px',
            //             '14px',
            //             '18px',
            //             '22px'
            //         ],
            //         allowCustomSize: false
            //     }
            // }
        });
    }

    function checkEditors(){

        // 2. Editor texto:
        if ($('.editor').length > 0) {
            $('.editor').trumbowyg({
                lang: "es",
                autogrow: true,
                removeformatPasted: true,
                svgPath: '/plugins/trumbowyg/ui/icons.svg',
                semantic: {
                    'div': 'div' // Editor does nothing on div tags now
                },
                semantic: false,
                btns: [
                    ['viewHTML'],
                    ['undo', 'redo'], // Only supported in Blink browsers
                    ['fontsize'],
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['foreColor', 'backColor'],
                    ['superscript', 'subscript'],
                    ['link'],
                    ['image'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['table'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                btnsDef: {
                    image: {
                        dropdown: ['insertImage', 'upload'],
                        ico: 'insertImage'
                    }
                },
                plugins: {
                    colors: {
                        colorList: [
                            'ffffff', '000000', 'eeece1', '1f497d', '4f81bd', 'c0504d', '9bbb59', '8064a2', '4bacc6', 'f79646', 'ffff00',
                            'f2f2f2', '7f7f7f', 'ddd9c3', 'c6d9f0', 'dbe5f1', 'f2dcdb', 'ebf1dd', 'e5e0ec', 'dbeef3', 'fdeada', 'fff2ca',
                            'd8d8d8', '595959', 'c4bd97', '8db3e2', 'b8cce4', 'e5b9b7', 'd7e3bc', 'ccc1d9', 'b7dde8', 'fbd5b5', 'ffe694',
                            'bfbfbf', '3f3f3f', '938953', '548dd4', '95b3d7', 'd99694', 'c3d69b', 'b2a2c7', 'b7dde8', 'fac08f', 'f2c314',
                            'a5a5a5', '262626', '494429', '17365d', '366092', '953734', '76923c', '5f497a', '92cddc', 'e36c09', 'c09100',
                            '7f7f7f', '0c0c0c', '1d1b10', '0f243e', '244061', '632423', '4f6128', '3f3151', '31859b', '974806', '7f6000',
                            '313131', '231f20', 'f40d18', 'd60812', 'd90711'
                        ],
                        displayAsList: false,
                    },
                    upload: {
                        serverPath: '/api/admin/upload-image-ajax',
                        fileFieldName: 'image',
                    },
                    resizimg: {
                        minSize: 64,
                        step: 16,
                    }
                }
                // plugins: {
                //     fontsize: {
                //         sizeList: [
                //             '11px',
                //             '12px',
                //             '14px',
                //             '18px',
                //             '22px'
                //         ],
                //         allowCustomSize: false
                //     }
                // }
            });
        }
    }

    window.checkEditors = checkEditors;

    function editorClose() {
        $('.editor').trumbowyg('destroy');
    }

    window.editorClose = editorClose;

    /**
     * Verifica el tag `can-edit` y agrega el evento click para instanciar el editor de texto
     * `trumbowyg` en el elemento, ademas agrega los botones de guardar y cancelar
     * 
     * @returns void
     */
    function instanceEditor(){

        let isAdmin = document.querySelector('main')?.classList.contains('user-auth-and-is-admin');
        if (!isAdmin) {
            return;
        }

        let elementsCanEditListeners = document.querySelectorAll('.can-edit');

        elementsCanEditListeners.forEach(el => {
            el.addEventListener('click', (event)=>{
                if(!el.classList.contains('editor')){
                    el.classList.add('editor');
                    // save old content
                    el.dataset.oldContent = el.innerHTML;
                    el.dataset.oldStyles = el.getAttribute('style');

                    // check class editor and set
                    window.checkEditors();

                    // insert container
                    insertAfter(el, createContainer({editorElement: el}));

                    // set main element class editor open
                    setMainElementClassEditorOpen();
                }
            })
        });
    }

    function setMainElementClassEditorOpen(){
        let mainEl = document.querySelector('main');
        mainEl.classList.add('editor-open');
    }

    function setMainElementClassEditorClose(){
        if (document.querySelectorAll('.trumbowyg-editor').length == 0) {
            let mainEl = document.querySelector('main');
            mainEl.classList.remove('editor-open');
        }
    }

    function getFromMainElementApiUrl(){
        let mainEl = document.querySelector('main');
        return mainEl.dataset.contentApiUrl;
    }

    function getFromMainElementParentContentId(){
        let mainEl = document.querySelector('main');
        return mainEl.dataset.contentId;
    }

    function insertAfter(referenceNode, newNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    function createContainer({editorElement}){
        let container = document.createElement('div');
        container.classList.add('position-absolute', 'bottom-0', 'right-0', 'm-2');
        container.classList.add('d-flex', 'flex-row', 'justify-content-end', 'align-items-center', 'gap-2');
        container.appendChild(createBtnCancel({editorElement}));
        container.appendChild(createBtnSave({editorElement}));
        return container;
    }

    function createBtnSave({editorElement}){
        let btnSave = document.createElement('button');
        btnSave.classList.add('btn', 'btn-primary', 'btn-sm', 'btn-save');
        btnSave.innerHTML = 'Guardar';
        btnSave.addEventListener('click', (event)=>{
            
            btnSave.disabled = true;

            saveData({dataElement: event.target.parentNode.previousSibling})
                .then(response => {

                    // destruimos el editor y volvemos a la normalidad
                    $(editorElement).trumbowyg('destroy');
                    editorElement.classList.remove('editor');
                    editorElement.style = editorElement.dataset.oldStyles;
                    setMainElementClassEditorClose();
                })           
        });
        return btnSave;
    }

    /**
     * Envia el contenido del elemento al servidor
     * 
     * @param {dataElement} Objeto con los datos a enviar 
     * @returns 
     */
    async function saveData({dataElement}){
        
        let api = getFromMainElementApiUrl();
        let id = dataElement.dataset.id ?? '0';
        let field = dataElement.dataset.field ?? '0';
        let lang = dataElement.dataset.lang ?? 'es';
        let parent_content_id = getFromMainElementParentContentId() ?? '0';
        let propagation_enabled = dataElement.dataset.propagationEnabled == 0 ? false : true;
        let modeTextPlain = dataElement.dataset.modeTextPlain == 1 ? true : false;
        let dataHTML = modeTextPlain ? dataElement.innerText : dataElement.innerHTML;

        let data = {
            id,
            field,
            lang,
            parent_content_id,
            propagation_enabled,
            dataHTML,
        }

        let response = await fetch(api, {
            method: 'POST',
            body: JSON.stringify(data),
            headers:{
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        })

        let result = await response.json();

        return result;
    }

    function createBtnCancel({editorElement}){
        let btnCancel = document.createElement('button');
        btnCancel.classList.add('btn', 'btn-danger', 'btn-sm', 'btn-cancel');
        btnCancel.innerHTML = 'Cancelar';
        btnCancel.addEventListener('click', (event)=>{
            $(editorElement).trumbowyg('destroy');
            editorElement.innerHTML = editorElement.dataset.oldContent.trim();
            editorElement.classList.remove('editor');
            editorElement.style = editorElement.dataset.oldStyles;
            setMainElementClassEditorClose();
        });
        return btnCancel;
    }

    instanceEditor();

});
